exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.dialog-content.min-width-500 {\n    min-width: 500px;\n}\n", ""]);
